import React from "react";
import { Box, Divider, Stack, Typography } from "@mui/material";
import { MultiMetricCardProps } from "../../type";
import { BaseCard } from "./BaseCard";
import { operationsDashboardStyles } from "../../styles";

export const MultiMetricCard: React.FC<MultiMetricCardProps> = ({ data }) => {
  return (
    <BaseCard data={data}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
      >
        {data.multiMetrics?.map((metric, index) => (
          <Stack
            key={`${metric.label}-${metric.value}-${metric.unit}`}
            direction="column"
            alignItems={index === 0 ? "flex-start" : "flex-end"}
          >
            <Box sx={operationsDashboardStyles.multiMetricValueContainer}>
              <Typography sx={operationsDashboardStyles.multiMetricValueText}>
                {metric.value}
              </Typography>
              {metric.unit && (
                <Typography sx={operationsDashboardStyles.multiMetricUnitText}>
                  {metric.unit}
                </Typography>
              )}
            </Box>

            <Typography
              sx={{
                ...operationsDashboardStyles.multiMetricLabelText,
                textAlign: index === 0 ? "left" : "right",
              }}
            >
              {metric.label}
            </Typography>

            {metric.infoText && (
              <Typography
                sx={{
                  ...operationsDashboardStyles.multiMetricInfoText,
                  textAlign: index === 0 ? "left" : "right",
                }}
              >
                {metric.infoText}
              </Typography>
            )}
          </Stack>
        ))}
      </Stack>

      {data.comparison && (
        <>
          <Divider
            sx={[
              operationsDashboardStyles.divider,
              operationsDashboardStyles.multiMetricDivider,
            ]}
          />
          <Box sx={operationsDashboardStyles.multiMetricComparisonContainer}>
            <Typography sx={operationsDashboardStyles.comparisonValue}>
              {data.comparison.value}
            </Typography>
            <Typography sx={operationsDashboardStyles.comparisonLabel}>
              {data.comparison.label}
            </Typography>
          </Box>
        </>
      )}
    </BaseCard>
  );
};
